import React, { useState } from "react";
import testimonials from "../data/testimonials";
import "../../css/home.css";
import "../../css/whychooseus.css";
import Slider from "react-slick";
import cert1 from "../../image/c1.webp";
import cert2 from "../../image/c2.webp";
import cert3 from "../../image/c3.webp";
import cert4 from "../../image/c4.webp";
import cert5 from "../../image/c5.webp";

const certificates = [cert1, cert2, cert3, cert4, cert5];

function Testimonials({ setShowModal }) {


  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    cssEase: "ease-in-out"
  };

  const testimonialSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: isMobile ? 1 : 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    cssEase: "ease-in-out"
  };

  return (
    <section id="test" className="py-3 py-lg-5" style={{ backgroundColor: "#1a2f55" }}>
      <style>{`
        .testimonial-premium-swiper .slick-track {
          display: flex !important;
        }
        .testimonial-premium-swiper .slick-slide {
          height: inherit !important;
        }
        .testimonial-premium-swiper .slick-slide > div {
          height: 100%;
        }
      `}</style>
      <div className="container">
        <div className="row align-items-center">


          <div className="col-lg-4 mt-5 mt-lg-0">
            <div className="certificate-wrapper bg-white p-3 p-md-4 rounded-4 shadow-lg position-relative" style={{ borderTop: "4px solid #e86229" }}>
              <div className="text-center mb-3">
                <h4 className="fw-bold" style={{ color: "#1a2f55" }}>Our Certifications</h4>
                <div style={{ width: "50px", height: "3px", backgroundColor: "#e86229", margin: "10px auto", borderRadius: "2px" }}></div>
              </div>
              <div className="cert-slider-container px-2 px-md-3">
                <Slider {...sliderSettings}>
                  {certificates.map((img, index) => (
                    <div key={index} className="outline-none">
                      <div className="d-flex justify-content-center align-items-center py-2" style={{ height: "250px" }}>
                        <img
                          src={img}
                          alt={`Certificate ${index + 1}`}
                          className="img-fluid rounded"
                          style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", filter: "drop-shadow(0 5px 10px rgba(0,0,0,0.1))" }}
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>

          {/* Right Column - Swiper */}
          <div className="col-lg-8" style={{ paddingTop: isMobile ? '20px' : '0' }}>
            <div className="ps-lg-4">
              <div className="mb-4 text-center text-lg-start">
                <h4 className="fw-bold text-white">What Our Clients Say</h4>
                <div style={{ width: "50px", height: "3px", backgroundColor: "#e86229", margin: "10px auto", marginLeft: "lg-0", borderRadius: "2px" }} className="mx-auto mx-lg-0"></div>
              </div>
              <div className="testimonial-premium-swiper pb-5">
                <Slider {...testimonialSettings}>
                  {testimonials.map((item, index) => (
                    <div key={index} className="px-2 outline-none h-100">
                      <div className="card border-0 h-100 p-4 position-relative overflow-hidden d-flex flex-column" style={{ borderRadius: "24px", backgroundColor: "#fff", boxShadow: "0 15px 35px rgba(0,0,0,0.2)" }}>

                        {/* Watermark Quote Icon */}
                        <div className="position-absolute" style={{ top: "-10px", right: "10px", opacity: "0.04", fontSize: "100px", color: "#1a2f55", fontFamily: "Georgia, serif", lineHeight: "1" }}>
                          "
                        </div>

                        {/* Rating */}
                        <div className="mb-3 text-warning">
                          {Array.from({ length: item.rating }).map((_, i) => (
                            <i key={i} className="bi bi-star-fill me-1" style={{ fontSize: "14px" }}></i>
                          ))}
                        </div>

                        {/* Message */}
                        <p className="text-dark mb-4 fst-italic" style={{ lineHeight: "1.8", fontSize: "15px", position: "relative", zIndex: 1 }}>
                          "{item.message}"
                        </p>

                        {/* Author Info */}
                        <div className="mt-auto d-flex align-items-center gap-3 pt-3 border-top border-light">
                          <img
                            src={item.img}
                            alt={item.name}
                            className="rounded-circle shadow-sm"
                            style={{ width: "50px", height: "50px", objectFit: "cover", border: "2px solid #e86229" }}
                          />
                          <div>
                            <h6 className="fw-bold mb-1" style={{ color: "#1a2f55", fontSize: "15px" }}>{item.name}</h6>
                            <small className="text-muted text-uppercase fw-bold" style={{ fontSize: "11px", letterSpacing: "1px" }}>{item.designation}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Testimonials;
